export default "__VITE_ASSET__B6HN30RZ__"